export default __webpack_public_path__ + "static/media/glygen-logoW-top.62037284.svg";